import { API, Designer } from "@brg/api";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDesignerById } from "shared/hooks/api/useDesignerById";

interface CoAuthorNameProps {
    coAuthor: Designer<'Global'>;
}
export const CompetitionWinnerName = ({item}: any) => {
    
    const hasCoAuthors = !!item?.coAuthors?.length;
    const renderCoAuthors = () => {
        return item.coAuthors.map((coAuthor: Designer<'Global'>, index: number) => (
          <React.Fragment key={coAuthor.designerId}>
            <CoAuthorName coAuthor={coAuthor} />
            {index < item.coAuthorIds.length - 1 ? ', ' : ''}
          </React.Fragment>
        ));
      };
    
      return (
        <span>
          {`${item.author?.name} ${item.author?.surName}`}
          {hasCoAuthors && ', '}
          {hasCoAuthors && renderCoAuthors()}
        </span>
      );
}

const CoAuthorName: FC<CoAuthorNameProps> = ({ coAuthor }) => {
    const { t, i18n: { language } } = useTranslation();
    const coAuthorLocal = API.toLang<Designer<'Local'>>(coAuthor, language);
 
    return <span>{`${coAuthorLocal?.name} ${coAuthorLocal?.surName}`}</span>;
  };import { API, Designer } from "@brg/api";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDesignerById } from "shared/hooks/api/useDesignerById";

interface CoAuthorNameProps {
    coAuthor: Designer<'Global'>;
}
export const CompetitionWinnerName = ({item}: any) => {
    
    const hasCoAuthors = !!item?.coAuthors?.length;
    const renderCoAuthors = () => {
        return item.coAuthors.map((coAuthor: Designer<'Global'>, index: number) => (
          <React.Fragment key={coAuthor.designerId}>
            <CoAuthorName coAuthor={coAuthor} />
            {index < item.coAuthorIds.length - 1 ? ', ' : ''}
          </React.Fragment>
        ));
      };
    
      return (
        <span>
          {`${item.author?.name} ${item.author?.surName}`}
          {hasCoAuthors && ', '}
          {hasCoAuthors && renderCoAuthors()}
        </span>
      );
}

const CoAuthorName: FC<CoAuthorNameProps> = ({ coAuthor }) => {
    const { t, i18n: { language } } = useTranslation();
    const coAuthorLocal = API.toLang<Designer<'Local'>>(coAuthor, language);
 
    return <span>{`${coAuthorLocal?.name} ${coAuthorLocal?.surName}`}</span>;
  };